import { render, staticRenderFns } from "./ScoreAlphaMaps.vue?vue&type=template&id=35cba617&scoped=true"
import script from "./ScoreAlphaMaps.vue?vue&type=script&lang=js"
export * from "./ScoreAlphaMaps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cba617",
  null
  
)

export default component.exports